var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, reaction } from "mobx";
import { NamedRoutes } from "./NamedRoutes";
import { NOT_LOADED } from "../Infra/RemoteData";
export class ExpiredPasswordUIManager {
    constructor(routingUIManager, authManager, provisioningService, persistence) {
        this.routingUIManager = routingUIManager;
        this.authManager = authManager;
        this.provisioningService = provisioningService;
        this.persistence = persistence;
        this.userEmailAddress = null;
        this.organization = NOT_LOADED;
        this.rememberedLoginData = persistence.getRememberedLoginData();
        reaction(() => routingUIManager.currentRoute, async (currentRoute) => {
            if ((currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.routeName) === NamedRoutes.EXPIRED_PASSWORD.routeName) {
                await this.populateUserEmail();
                await this.loadOrganization();
            }
        }, { fireImmediately: true });
    }
    async populateUserEmail() {
        var _a, _b;
        this.userEmailAddress = (_b = (_a = this.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.userEmailAddress) !== null && _b !== void 0 ? _b : null;
    }
    async loadOrganization() {
        var _a, _b;
        const organizationId = (_a = this.authManager.orgId) !== null && _a !== void 0 ? _a : (_b = this.rememberedLoginData) === null || _b === void 0 ? void 0 : _b.organizationId;
        if (organizationId === null || organizationId === undefined) {
            this.organization = null;
            return;
        }
        try {
            this.organization = await this.provisioningService.getOrganizationPublicProfileById(organizationId);
        }
        catch {
            this.organization = null;
        }
    }
}
__decorate([
    observable
], ExpiredPasswordUIManager.prototype, "userEmailAddress", void 0);
__decorate([
    observable
], ExpiredPasswordUIManager.prototype, "organization", void 0);
__decorate([
    observable
], ExpiredPasswordUIManager.prototype, "rememberedLoginData", void 0);
